<template>

    <div class="page workorder">
        <div class="gridheader">
            <div class="row wrapper">
                <div class="col-md-4 title">
                    <div class="row">
                        <div class="col-2 col-md-1">
                            <a v-on:click="back"><img src="../assets/img/arrow-left-white.svg" alt=""></a>
                        </div>
                        <div class="col-10 col-md-11 namescol">
                            <span>{{$t('DENTALSOLUTION')}}: {{dentalSolution.dentalSolutionId}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-6 namescol">
                            <span>{{$t('CLIENT')}}</span>
                            <a v-on:click.prevent="startChatByUserIdDental(dentalSolution.ordererUserId, dentalSolution.dentalSolutionId)"><img src="../assets/img/chat-name-icon.svg" alt="" /> {{dentalSolution.ordererName}} {{dentalSolution.ordererSurname}}</a>
                        </div>
                        <div class="col-6 namescol">
                            <span>{{$t('DENTALSOLUTIONCOMPANY')}}</span>
                            <a v-on:click.prevent="startChatByUserIdDental(dentalSolution.tehnicianUserId, dentalSolution.dentalSolutionId)"><img src="../assets/img/chat-name-icon.svg" alt="" /> {{dentalSolution.workerCompany}}</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 action">
                    <template v-if="notifyOrOrder">
                        <button class="btn btn-white d-none d-md-block" v-on:click="showNoticeModal = true">{{ $t('NOTIFY')}}</button>
                    </template>
                    <template v-else-if="globals.auth != 9 && (dentalSolution.status == 'open' || dentalSolution.status == 'notice') && dentalSolution.files && dentalSolution.files.length > 0">
                        <button class="btn btn-white d-none d-md-block" v-on:click="changeOrderStatus(dentalSolution.dentalSolutionId, 'ordered')">{{ $t('ORDER')}}</button>
                    </template>
                    <template v-if="globals.auth == 9 && dentalSolution.status == 'ordered'">
                        <button class="btn btn-white d-none d-md-block" v-on:click="changeOrderStatus(dentalSolution.dentalSolutionId, 'inprocess')">{{ $t('INPROCESS')}}</button>
                    </template>
                    <template v-if="globals.auth == 9 && dentalSolution.status == 'inprocess'">
                        <button class="btn btn-white d-none d-md-block" v-on:click="changeOrderStatus(dentalSolution.dentalSolutionId, 'finished')">{{ $t('FINISH')}}</button>
                    </template>
                    
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-3 first-col d-none d-md-block">
                <div class="header">
                    <div class="row">
                        <h2>{{$t('PRODUCTLIST')}}</h2>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <a v-on:click.prevent="category = 'printing'" v-bind:class="(category == 'printing') ? 'active' : ''">{{$t('PRINTING')}}</a>
                        </div>
                        <div class="col-md-6">
                            <a v-on:click.prevent="category = 'milling'" v-bind:class="(category == 'milling') ? 'active' : ''">{{$t('MILLING')}}</a>
                        </div>
                    </div>
                </div>
                <div class="list-container">
                    <ul>
                        <li v-for="ds in filteredDentalSolutionTypes" :key="ds.dentalSolutionTypeId">
                            <input type="radio" v-on:change="updateProperty(dentalSolution.dentalSolutionId, {dentalSolutionTypeId: dentalSolution.dentalSolutionTypeId})" v-model="dentalSolution.dentalSolutionTypeId" name="dentalSolutionTypeId" :value="ds.dentalSolutionTypeId" /> {{$t(ds.name)}}
                        </li>
                    </ul>
                    <div class="col-md-12">
                        <div class="form-group pb-3 mt-3">
                            <label>{{ $t('NUMBEROFITEMS')}}</label>
                            <input type="text" v-on:change="updateProperty(dentalSolution.dentalSolutionId, {num: dentalSolution.num})" class="form-control" name="num" v-model="dentalSolution.num" />
                        </div>
                    </div>
                    <div class="col-md-12" v-if="hasColor">
                        <div class="form-group pb-3">
                            <label>{{ $t('COLOR')}}</label>
                            <select name="color" v-on:change="updateProperty(dentalSolution.dentalSolutionId, {color: dentalSolution.color})" v-model="dentalSolution.color" class="form-control secondary">
                                <option v-for="color in colors" :key="color" v-bind:value="color">{{color}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group mb-0">
                            <b-form-checkbox class="grey" v-model="dentalSolution.isRepeat" value="1" unchecked-value="0">{{$t('ISREPEAT')}}</b-form-checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 d-none d-md-block dentalsolution">
                <div class="row">
                    <div class="status-container" v-if="dentalSolution.status">
                        <div class="status">{{ $t('DENTALSOLUTIONSTATUS')}}: <span>{{$t('DS_'+dentalSolution.status.toUpperCase())}}</span></div>
                    </div>
                </div>
                <div class="row">
                    <div class="stl-container">
                        <div class="row title" v-if="dentalSolution.files">
                            <div class="col-6 text-left">
                                <span>{{$t('UPLOADED')}}:</span> {{dentalSolution.files.length}} {{$t('FILES')}}
                            </div>
                            <div class="col-6 text-right">
                                {{$t('SAVEALL')}} <a class="btn btn-secondary" target="_blank" :href="'/rest/DentalSolutions/saveAll?dentalSolutionId='+dentalSolution.dentalSolutionId" v-on:click="delayedReload"><img src="../assets/img/icon-save.svg"></a>
                            </div>
                        </div>
                        <div class="row files">
                            <div class="col-12">
                                <div class="loading" v-if="loading">
                                    <icon name="spinner" scale="2" spin></icon>
                                </div>
                                <ul v-else-if="dentalSolution.files">
                                    <li v-for="file in dentalSolution.files" :key="file.dentalSolutionFileId" class="mb-4">
                                        <div class="file">
                                            {{file.name}}
                                            <button class="btn btn-secondary" v-on:click="deleteStl(file.dentalSolutionFileId)"><img src="../assets/img/x-circle.svg"></button>
                                        </div>
                                        <a class="btn btn-secondary" target="_blank" :href="'/rest/DentalSolutions/downloadStl?dentalSolutionFileId='+file.dentalSolutionFileId+'&dentalSolutionId='+dentalSolution.dentalSolutionId" v-on:click="delayedReload"><img src="../assets/img/icon-save.svg"></a>
                                        <img v-if="file.downloaded == '1'" src="../assets/img/checkmark-status-icon-on.svg" alt="">
                                        <img v-else src="../assets/img/checkmark-status-icon-off.svg" alt="">
                                        <div class="form-group" v-if="globals.auth == 9">
                                            <label>{{ $t('PLATFORM')}}</label>
                                            <select class="form-control" name="platform" v-model="file.platform" v-on:change="changeFilePlatform(file)">
                                                <option v-for="pl in platform" :key="pl" :value="pl">{{pl}}</option>
                                            </select>
                                        </div>
                                    </li>
                                </ul>
                                <div class="upload" v-if="!loading">
                                    <form enctype="multipart/form-data" novalidate>
                                        <input type="file" multiple name="stlSrc" @change="filesChange($event.target.name, $event.target.files)" accept="application/sta">
                                        <div class="upl-container">
                                            <a class="btn btn-primary d-none d-md-block mb-3"><img src="../assets/img/icon-novi-nalog.svg" alt=""> {{$t('ADDFILE')}}</a>
                                            <span>{{$t('ORDRAGANDDROP')}}</span>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="col-lg-3 last-col">
                <template v-if="showInfo">
                    <div class="col-item" v-b-toggle.notice>{{$t('NOTICE')}} <span class="down"></span></div>
                    <b-collapse accordion="right-accordion" v-bind:visible="dentalSolution.notice != ''" id="notice">
                        <textarea v-model="dentalSolution.notice" v-on:change="updateProperty(dentalSolution.dentalSolutionId, {notice: dentalSolution.notice})" name="notice" class="form-control secondary"></textarea>
                    </b-collapse>
                    <div v-if="dentalSolution.status == 'ordered'" class="col-item" v-b-toggle.talks>{{$t('TALKS')}} <span class="down"></span> <a class="flexright"><img v-b-modal.newchat src="../assets/img/plus-circle.svg" alt=""></a></div>
                    <b-collapse v-if="dentalSolution.status == 'ordered'" accordion="right-accordion" id="talks" v-bind:visible="chatvisible" class="tasks">
                        <div>
                            <ul>
                                <li v-for="talk in talks" :key="talk.workOrderTalkId" v-on:click.prevent="startChatByUserIdDental((talk.toUserId == globals.userId ? talk.fromUserId : talk.toUserId), dentalSolution.dentalSolutionId)">
                                    <div>
                                        <div>
                                            <span class="user"><img src="../assets/img/chat-name-icon-blue.svg" alt=""> {{talk.name}} {{talk.surname}} <img src="../assets/img/chat-user-flow-pointer.svg" alt="" /> {{talk.toName}} {{talk.toSurname}}</span>
                                            <span class="date">{{returnTalkTime(talk.dateTime)}}</span>
                                        </div>
                                    </div>
                                    <div class="inner">
                                        {{talk.text}}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </b-collapse>
                </template>
                <div class="status-container mt-2" v-if="dentalSolution.notifyDate">
                    <div class="status">{{ $t('NOTIFYDATE')}}: <span>{{dentalSolution.notifyDate}}</span></div>
                </div>
            </div>
        </div>

        <b-modal centered size="sm" ref="newchat" id="newchat" v-bind:ok-title="$t('STARTCHAT')" v-bind:cancel-title="$t('CANCEL')" v-on:ok="startChat" v-bind:title="$t('NEWCHAT')">
            <form method="get" action="">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label>{{ $t('SELECTUSER')}}</label>
                            <b-form-select v-model="chatUserId" :plain="true" v-bind:options="possibleUsers.root" value-field="userId" text-field="nameSurname" class="form-control secondary" v-bind:placeholder="$t('SELECTUSER')"></b-form-select>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </b-modal>

        <b-modal centered size="sm" v-model="showNoticeModal" v-bind:ok-title="$t('NOTIFY')" v-bind:cancel-title="$t('CANCEL')" v-on:ok="updateProperty(dentalSolution.dentalSolutionId, {notifyDate: formatDate(dentalSolution.notifyDate)}); changeOrderStatus(dentalSolution.dentalSolutionId, 'notice')" v-bind:title="$t('NOTIFY')">
            <form method="get" action="">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label>{{ $t('SELECTDATE')}}</label>
                            <datepicker v-model="dentalSolution.notifyDate" input-class="secondary" :bootstrapStyling="true" format="dd.MM.yyyy" v-bind:placeholder="$t('NOTIFICATIONDATE')"></datepicker>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </b-modal>

        

    </div>
</template>

<script>
import
{
    mapActions,
    mapGetters
}
from 'vuex'
import Vue from 'vue'
import usersApi from '@/api/users'
import dentalsolutionsApi from '@/api/dentalsolutions'
import workordersApi from '@/api/workorders'
import workorderstalksApi from '@/api/workordertalks'
import dentalsolutiontypesApi from '@/api/dentalsolutiontypes'
var moment = require('moment');

export default
{
    name: 'DentalSolution',
    data: function()
    {
        return {
            solutionLoaded: false,
            dentalSolutionId: false,
            showNoticeModal: false,
            chatUserId: false,
            dentalsolutiontypes:
            {},
            category: 'printing',
            dentalSolution:
            {},
            talks: [],
            possibleUsers:
            {},
            chatvisible: false,
            colors: ['A1', 'A2', 'A3'],
            selectedColor: false,
            showCenterPart: true,
            showInfo: true,
            loading: false,
            platform: ['p1', 'p2', 'p3', 'p4', 'p5', 'p6', 'p7', 'p8', 'p9', 'p10'],
        };
    },
    async created()
    {
        var me = this;

        me.dentalSolutionId = me.$route.params.dentalSolutionId;

        me.chatvisible = false;

        if (typeof me.$route.query.open != 'undefined' && me.$route.query.open == 'chat')
        {
            me.chatvisible = true;
        }

        await me.getDentalSolution();

        me.getDentalSolutionTypes();

        setInterval(function()
        {
            if (window.innerWidth >= 768) me.showCenterPart = true;
            else if (me.mobileTab == 'protetic') me.showCenterPart = true;
            else me.showCenterPart = false;

            if (window.innerWidth >= 768) me.showInfo = true;
            else if (me.mobileTab == 'info') me.showInfo = true;
            else me.showInfo = false;
        }, 1000);
    },
    methods:
    {
        delayedReload()
        {
            const me = this;

            setTimeout(() =>
            {
                me.getDentalSolution();
            }, 1000);
        },
        formatDate(date)
        {
            return moment(date).format('YYYY-MM-DD');
        },
        async updateProperty(dentalSolutionId, params)
        {
            const me = this;

            me.loading = true;

            await dentalsolutionsApi.saveDentalSolution({...params, id: dentalSolutionId}, function(data)
            {
                me.loading = false;

                if (data.error && data.error == true)
                {
                    Vue.$notify.error(data.notice);
                }

                me.getDentalSolution();
            });
        },
        async changeOrderStatus(dentalSolutionId, status)
        {
            const me = this;

            me.$store.commit('setModalAlert',
            {
                text: me.$i18n.t('AREYOUSHURE'),
                btnAction: async function()
                {
                    me.loading = true;

                    await dentalsolutionsApi.saveDentalSolution({id: dentalSolutionId, status}, function(data)
                    {
                        me.loading = false;

                        if (data.error && data.error == true)
                        {
                            Vue.$notify.error(data.notice);
                        }

                        me.getDentalSolution();
                    });
                }
            });
        },
        async changeFilePlatform(file)
        {
            const me = this;

            me.loading = true;

            await dentalsolutionsApi.changeFilePlatform({dentalSolutionFileId: file.dentalSolutionFileId, dentalSolutionId: me.dentalSolutionId, platform: file.platform}, function(data)
            {
                me.loading = false;

                if (data.error && data.error == true)
                {
                    Vue.$notify.error(data.notice);
                }

                me.getDentalSolution();
            });
        },
        async filesChange(fieldName, fileList)
        {
            const me = this;

            me.loading = true;

            await dentalsolutionsApi.uploadStl({...fileList, dentalSolutionId: me.dentalSolutionId}, function(data)
            {
                me.loading = false;

                if (data.error && data.error == true)
                {
                    Vue.$notify.error(data.notice);
                }

                me.getDentalSolution();
            });
        },
        async deleteStl(dentalSolutionFileId)
        {
            const me = this;

            me.loading = true;

            await dentalsolutionsApi.deleteStl({dentalSolutionFileId, dentalSolutionId: me.dentalSolutionId}, function(data)
            {
                me.loading = false;

                if (data.error && data.error == true)
                {
                    Vue.$notify.error(data.notice);
                }

                me.getDentalSolution();
            });
        },
        getDentalSolutionTypes()
        {
            const me = this;
            dentalsolutiontypesApi.selectRow({}, function(data)
            {
                if (data.error && data.error == true)
                {
                    Vue.$notify.error(data.notice);
                    return;
                }

                if (data.root)
                {
                    for (var i = 0; i < data.root.length; i++)
                    {
                        var ds = data.root[i];
                        if(ds.dentalSolutionTypeId == me.dentalSolution.dentalSolutionTypeId)
                        {
                            me.category = ds.category;
                        }
                    }
                }

                me.dentalsolutiontypes = Object.assign({}, data);
            });
        },
        async getDentalSolution()
        {
            var me = this;

            me.loading = true;

            await dentalsolutionsApi.getDentalSolutions(
            {
                dentalSolutionId: me.dentalSolutionId
            }, function(data)
            {
                me.loading = false;
                
                if (data.error && data.error == true)
                {
                    Vue.$notify.error(data.notice);
                    return;
                }

                me.dentalSolution = Object.assign({}, data.root[0]);

                me.getTalks();
                me.getDentalSolutionPossibleUsers(
                {});

                me.$nextTick(() =>
                {
                    me.solutionLoaded = true;
                })
            });
        },
        returnTalkTime(dateTime)
        {
            return moment(dateTime).format('DD.MM.YYYY. (HH:mm)')
        },
        startChat()
        {
            var me = this;
            this.$store.commit('setChatData',
            {
                chatUserId: me.chatUserId,
                dentalSolutionId: me.dentalSolutionId
            })
        },
        getDentalSolutionPossibleUsers: function(params)
        {
            var me = this;
            dentalsolutionsApi.getDentalSolutionPossibleUsers(
            {
                ...params,
                dentalSolutionId: me.dentalSolutionId
            }, function(data)
            {
                if (data.error && data.error == true)
                {
                    Vue.$notify.error(data.notice);
                    return;
                }
                me.possibleUsers = data;
            });
        },
        getTalks: function()
        {
            var me = this;
            workorderstalksApi.selectAllDentalSolutionChats(
            {
                dentalSolutionId: me.dentalSolution.dentalSolutionId
            }, function(data)
            {
                if (data.error && data.error == true)
                {
                    me.$notify.error(data.notice);
                    return;
                }
                me.talks = data.root;
            });
        },
    },
    watch:
    {
        'dentalSolution.isRepeat'(value)
        {
            const me = this;

            if(me.solutionLoaded)
            {
                me.updateProperty(me.dentalSolution.dentalSolutionId, {isRepeat: value});
            }
        }
    },
    computed:
    {
        ...mapGetters([
            'globals'
        ]),
        notifyOrOrder()
        {
            const me = this;
            
            if(me.globals.auth != 9 && me.dentalSolution.files !== undefined)
            {
                if(me.dentalSolution.files.length > 0)
                {
                    return false;
                }
                else if(me.dentalSolution.status == 'open')
                {
                    return true;
                }
            }

            return false;
        },
        filteredDentalSolutionTypes: function()
        {
            var me = this;

            var out = [];

            if (me.dentalsolutiontypes.root)
            {
                for (var i = 0; i < me.dentalsolutiontypes.root.length; i++)
                {
                    var ds = me.dentalsolutiontypes.root[i];
                    if (ds.category == me.category)
                    {
                        out.push(ds);
                    }
                }
            }

            return out;
        },
        hasColor()
        {
            var me = this;

            var out = [];
            if (me.dentalsolutiontypes.root)
            {
                for (var i = 0; i < me.dentalsolutiontypes.root.length; i++)
                {
                    var ds = me.dentalsolutiontypes.root[i];
                    if (ds.dentalSolutionTypeId == me.dentalSolution.dentalSolutionTypeId && ds.hasColor == 1)
                    {
                        return true;
                    }
                }
            }

            return false;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/DentalSolution.vue